var React = require('react');

function IcPhotoCamera (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.8301 2H18C19.1 2 20 2.9 20 4V16C20 17.1 19.1 18 18 18H2C0.9 18 0 17.1 0 16V4C0 2.9 0.9 2 2 2H5.16992L7 0H13L14.8301 2ZM6.0498 4H2V16H18V4H13.9502L12.1201 2H7.87988L6.0498 4ZM10 5C12.76 5 15 7.24 15 10C15 12.76 12.76 15 10 15C7.24 15 5 12.76 5 10C5 7.24 7.24 5 10 5ZM10 7C8.35 7 7 8.35 7 10C7 11.65 8.35 13 10 13C11.65 13 13 11.65 13 10C13 8.35 11.65 7 10 7Z","fill":"currentColor"}));
}

IcPhotoCamera.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = IcPhotoCamera;

IcPhotoCamera.default = IcPhotoCamera;
